import type { SearchParamOptions } from '@/types';
import { SearchResponse } from 'typesense/lib/Typesense/Documents';

export function formatFilterParams(params: Partial<SearchParamOptions>) {
  const filterMap: any = {
    tags: 'tag_slugs',
    shop_id: 'shop_id',
    types: 'type_slug',
    aiModels: 'ai_model_slug',
    categories: 'category_slugs',
    status: 'status',
    is_custom_ai_model: 'is_custom_ai_model',
    // Add more mappings here
  };

  if (params.refineBy && params.refineBy.includes('prompt') && params.refineBy.includes('model')) {
    delete params.refineBy;
  }

  const filterGroups = Object.entries(params)
    .filter(([, value]) => Boolean(value)) // Filter out undefined or null values
    .map(([key, value]) => {
      if (key === 'refineBy') {
        if (value.includes('prompt') && value.includes('model')) return '';
        else if (value.includes('prompt')) return `is_custom_ai_model:false`;
        else if (value.includes('model')) return `is_custom_ai_model:true`;
        else return '';
      }
      if (
        [
          'types',
          'categories',
          'aiModels',
          'tags',
          'author',
          'manufacturer',
        ].includes(key)
      ) {
        // Split the comma-separated string into an array, map each element, and wrap with parentheses
        return `(${(value as string)
          .split(',')
          .map((v) => `${filterMap[key]}:${v.trim()}`)
          .join(' || ')})`;
      } else {
        // For non-array fields, directly return the mapping
        return `${filterMap[key]}:${value}`;
      }
    });

  return filterGroups.join(' && '); // Join all group filters with the AND operator
}

interface PaginatedResponse {
  current_page: number;
  from: number;
  last_page: number;
  per_page: number;
  to: number;
  total: number;
  data: Array<object>;
}

export function formatTypesenseToLaravelPagination(
  response: SearchResponse<object>,
  currentPage: number,
  perPage: number
): PaginatedResponse {
  const totalHits = response.found;
  const totalPages = Math.ceil(totalHits / perPage);
  const from = (currentPage - 1) * perPage + 1;
  const to = Math.min(from + perPage - 1, totalHits);

  const data = response.hits ? response.hits?.map((hit) => hit.document) : [];

  return {
    current_page: currentPage,
    from,
    last_page: totalPages,
    per_page: perPage,
    to,
    total: totalHits,
    data,
  };
}
